export const filterFalsy = <T>(thing: T | null | undefined): thing is T => !!thing;

export const stringOrNull = (thing: unknown) => (thing ? `${thing}` : null);

export type TMaybe<T> = T | null | undefined;
